import styled from "styled-components";
import { SegmentedPicker } from "../../molecules/SegmentedPicker";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing[3]};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
`;

export const Heading = styled.h2`
  margin: 0;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const MatchGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const MatchLabel = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const MatchPicker = styled(SegmentedPicker)`
  flex-shrink: 0;
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
`;

export const OperatorSeparator = styled.p`
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.lowEmphasis};
`;

export const NotificationText = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;
